import { FC } from "react";
import styles from "./MouseAndKeyboardTutorial2D.module.less";

interface MouseAndKeyboardTutorial2DProps {}

const IMAGES_DEFAULT_WIDTH_SIZE = 30;

const CTRL_IMAGE = "/icons/mouseAndKeyboard/ctrl-40.png";
const LEFT_CLICK_IMAGE = "/icons/mouseAndKeyboard/left-click-40.png";
const MOVE_IMAGE = "/icons/mouseAndKeyboard/move-40.png";
const MOUSE_SCROLLING_IMAGE = "/icons/mouseAndKeyboard/mouse-scrolling-40.png";
const RIGHT_CLICK_IMAGE = "/icons/mouseAndKeyboard/right-click-40.png";

export const MouseAndKeyboardTutorial2D: FC<
  MouseAndKeyboardTutorial2DProps
> = () => {
  return (
    <div className={styles.mouseAndKeyboardTutorial}>
      <div className={styles.title}>
        <h4>Keyboard and Mouse Controls</h4>
      </div>

      <div className={styles.content}>
        <div className={styles.infoContainer}>
          <span className={styles.infoText}> Pan Camera </span>
          <img src={CTRL_IMAGE} width={IMAGES_DEFAULT_WIDTH_SIZE} alt="" />
          <span> + </span>
          <img
            src={LEFT_CLICK_IMAGE}
            width={IMAGES_DEFAULT_WIDTH_SIZE}
            alt=""
          />
          <span className={styles.infoText}> + </span>
          <img src={MOVE_IMAGE} width={IMAGES_DEFAULT_WIDTH_SIZE} alt="" />
        </div>

        <div className={styles.infoContainer}>
          <span className={styles.infoText}>Pan Camera</span>
          <img
            src={RIGHT_CLICK_IMAGE}
            width={IMAGES_DEFAULT_WIDTH_SIZE}
            alt=""
          />
          <span className={styles.infoText}>+</span>
          <img src={MOVE_IMAGE} width={IMAGES_DEFAULT_WIDTH_SIZE} alt="" />
        </div>

        <div className={styles.infoContainer}>
          <span className={styles.infoText}>Zoom In/Out</span>
          <img
            src={MOUSE_SCROLLING_IMAGE}
            width={IMAGES_DEFAULT_WIDTH_SIZE}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};
